import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { HistoricalCustomerMedicalAlertModalComponent } from './historical-customer-medical-modal.component';
import { HistoricalMedicalAlertsComponent } from './historical-customer-medical.component';

@NgModule({
    declarations: [
        HistoricalCustomerMedicalAlertModalComponent,
        HistoricalMedicalAlertsComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        HistoricalCustomerMedicalAlertModalComponent,
        HistoricalMedicalAlertsComponent
    ]
})

export class HistoricalMedicalModule { }
